import { render } from "./ComponenteBarridos.vue?vue&type=template&id=76c63578&scoped=true"
import script from "./ComponenteBarridos.vue?vue&type=script&lang=js"
export * from "./ComponenteBarridos.vue?vue&type=script&lang=js"

import "./ComponenteBarridos.vue?vue&type=style&index=0&id=76c63578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c63578"]])

export default __exports__